
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from '@/store'
import { CourseCatalogItem } from '@/store/superAdmin'

export default defineComponent({
  name: 'CourseListView',
  setup() {
    const store = useStore()
    const loading = ref(false)
    const error = ref<string | null>(null)
    const visibilityMap = ref<Record<string, string[]>>({})
    const deleteTarget = ref<CourseCatalogItem | null>(null)
    const deleting = ref(false)

    const courses = computed(() => store.getters['superAdmin/getCourses'])

    async function loadCourses() {
      loading.value = true
      error.value = null
      try {
        await store.dispatch('superAdmin/LOAD_COURSES')
        await loadVisibilities()
      } catch (e: any) {
        error.value = 'Kurse konnten nicht geladen werden.'
      } finally {
        loading.value = false
      }
    }

    async function loadVisibilities() {
      const jwt = store.getters['getJWT']
      const all: CourseCatalogItem[] = store.getters['superAdmin/getCourses']
      const results: Record<string, string[]> = {}
      await Promise.all(
        all.map(async (c) => {
          try {
            const data = await store.dispatch('superAdmin/GET_VISIBILITY', { courseId: c.courseId, jwt })
            results[c.courseId] = data.orgIds
          } catch {
            results[c.courseId] = ['*']
          }
        }),
      )
      visibilityMap.value = results
    }

    function confirmDelete(course: CourseCatalogItem) {
      deleteTarget.value = course
    }

    async function doDelete() {
      if (!deleteTarget.value) return
      deleting.value = true
      try {
        await store.dispatch('superAdmin/DELETE_COURSE', deleteTarget.value.courseId)
        deleteTarget.value = null
      } catch {
        error.value = 'Kurs konnte nicht gelöscht werden.'
      } finally {
        deleting.value = false
      }
    }

    onMounted(loadCourses)

    return { courses, loading, error, visibilityMap, deleteTarget, deleting, confirmDelete, doDelete }
  },
})
